import { lazy, Suspense } from 'react';
import { Outlet, Route } from 'react-router-dom';

import ErrorBoundaryContainer from '../../components/ErrorBoundaryContainer';
import Loading from '../../components/Loading';

import accountRouter from '../account';

const MultiStoreyDashboardComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "multi-storey-dashboard" */ '../../pages/multi-storey-dashboard'
    ),
);

const attendanceDashboardRouter = (
  <Route path="multi-storey-dashboard" element={<Outlet />}>
    <Route
      path=":projectId"
      element={
        <Suspense fallback={<Loading />}>
          <ErrorBoundaryContainer
            key="multi-storey-dashboard"
            component={<MultiStoreyDashboardComponent />}
          />
        </Suspense>
      }
    >
      {accountRouter()}
    </Route>
  </Route>
);

export default attendanceDashboardRouter;
